import { TFunction } from 'i18next';
import { ESCycle } from '~src/interfaces/cycle.interface';

import { ESQuestion } from '~src/interfaces/question.interface';
import { getAnonymousSegment, Segment, segmentEquals, SegmentType, } from '~src/interfaces/segment.interface';
import { ESTopic } from '~src/interfaces/topic.interface';
import { getNameOfSegment } from '~src/services/getNameOfSegment';
import {
  SpiderChartDimensions,
  SurveyWithTopics,
  TopicWithQuestions,
} from '~src/store/spidergraph/spidergraph.reducer';

import { displayCycleString } from './components/LinesSelector';

export interface AnalysisLinePoint {
  value: number;
  numberOfAnswers?: number;
  edgeId: string;
  axisEntity?: ESQuestion | ESTopic;
}

export class AnalysisLine {
  static getDummyLine(chartDimensions: SpiderChartDimensions): AnalysisLine {
    const toqs = Object.values(
      (chartDimensions as SurveyWithTopics).topics || (chartDimensions as TopicWithQuestions).questions,
    );
    const edgeIds = toqs.map(e => e.id);

    const line = new AnalysisLine(
      edgeIds.map(id => ({ edgeId: id, value: 0, numberOfAnswers: 0 })),
      getAnonymousSegment(),
      getAnonymousSegment()
    );
    line.isDummy = true;
    return line;
  }

  protected isDummy: boolean = false;

  constructor(
    public points: AnalysisLinePoint[],
    public about: Segment,
    public ask: Segment,
    public cycle?: ESCycle,
  ) {}

  getLineId() {
    return [this.about.id, this.ask.id, this.cycle && this.cycle.id].filter(Boolean).join(';');
  }

  getColor(): string | undefined {
    return this.isDummy ? 'rgba(255,255,255,1)' : undefined;
  }

  getLabel(t: TFunction): string {
    if (this.isDummy) {
      return '';
    }

    let nameOfSegment = '';
    if (this.ask.type === SegmentType.Company) {
      nameOfSegment = getNameOfSegment(t, this.about);
    } else if (this.about.type === SegmentType.Company) {
      nameOfSegment = getNameOfSegment(t, this.ask);
    } else if (segmentEquals(this.ask, this.about)) {
      nameOfSegment = t('x.analysis.spider-web.line-label.self').replace('%s', getNameOfSegment(t, this.ask))
    } else {
      nameOfSegment = t('x.analysis.spider-web.line-label.ask-about').replace('%1', getNameOfSegment(t, this.ask)).replace('%2', getNameOfSegment(t, this.about));
    }

    const nameOfCycle = this.cycle && displayCycleString(t, this.cycle);

    return `${nameOfSegment} – ${nameOfCycle || t('x.analysis.spider-web.graph.cycle-average')}`;
  }
}
